import { all, fork } from "redux-saga/effects";

import Alert from "./Alert/saga";

//public
import AuthSaga from "./auth/login/saga";
import Register from "./auth/register/saga";
import Profile from "./auth/profile/saga";

// File
import File from "./File/saga";

// Home
import home from "./home/saga";

// Collections
import collections from "./collection/saga";

// Categories
import categories from "./category/saga";

// Items
import items from "./items/saga";

import notifications from "./notification/saga";

// Content Pages
import contentpage from "./contentpage/saga";

// art page
import art from "./art/saga";
import museums from "./museums/saga";
import Transactions from "./transaction/saga";
import SellItems from "./sellItem/saga";
import Owner from "./owner/saga";
import Referral from "./Referral/saga";
import PrintSaga from "./Print/saga";
import CustomPrintSaga from "./customArtwork/saga";
import addPhysicalSellItem from "./physicalSellItem/saga";
export default function* rootSaga() {
  yield all([
    fork(Alert),
    fork(AuthSaga),
    Register(),
    fork(Profile),
    fork(File),
    fork(home),
    fork(collections),
    fork(categories),
    fork(items),
    fork(notifications),
    fork(contentpage),
    fork(art),
    fork(museums),
    fork(Owner),
    fork(Transactions),
    fork(SellItems),
    fork(addPhysicalSellItem),
    fork(Referral),
    fork(PrintSaga),
    fork(CustomPrintSaga),
  ]);
}
